<template>
    <section class="page__404" v-if="result" id="content">

        <div class="wrapper">
            <intro-component :intro="result.page404.data.attributes.intro.Intro"
                            :isCover="true"
                            :button="result.page404.data.attributes.intro.Button"
                            :button-class="'secondary-accent'"
            ></intro-component>
        </div>

        <span class="page__404__noise"></span>

        <div class="standing-in-rain">

        </div>

        <Seo :seoData="result.page404.data.attributes.seo"/>

    </section>
</template>


<script lang="ts">

    import { defineComponent, ref } from 'vue'
    import gql from 'graphql-tag'

    import { useQuery } from '@vue/apollo-composable'
    import { PAGE_QUERY } from '../graphql/page404'

    import IntroComponent from '../components/IntroComponent.vue'
    import Seo from '../components/navigation/Seo.vue'

    export default defineComponent({
        components: {
            IntroComponent,
            Seo,
        },
        setup() {
            const homeurl: string = import.meta.env.VITE_API_URL

            const page_query = ref(PAGE_QUERY)
            const { result } = useQuery(page_query)

            return {
                result
            }
        }
    })
</script>
